import {
  GET_YEAR_QUESTIONS_REQUEST,
  GET_YEAR_QUESTIONS_SUCCESS,
  GET_YEAR_QUESTIONS_FAIL,
  GET_AVAILABLE_YEARS_REQUEST,
  GET_AVAILABLE_YEARS_SUCCESS,
  GET_AVAILABLE_YEARS_FAIL,
  CLEAR_AVAILABLE_YEARS,
  CLEAR_ERRORS,
} from "./../constants/questionConstants";

export const yearQuestionsReducer = (
  state = {
    questions: [],
    availableYears: [],
    yearsLoading: false,
    qLoading: false,
  },
  action
) => {
  switch (action.type) {
    case GET_YEAR_QUESTIONS_REQUEST:
      // Preserve existing state (like availableYears) while we fetch questions
      return {
        ...state,
        qLoading: true,
        questions: [],
      };
    case GET_AVAILABLE_YEARS_REQUEST:
      return {
        ...state,
        yearsLoading: true,
      };

    case GET_YEAR_QUESTIONS_SUCCESS:
      return {
        ...state,
        qLoading: false,
        questions: action.payload.questionsList,
        questionCount: action.questionCount,
        examData: action.currentExam,
        // Only override availableYears if a non-empty array is provided; otherwise preserve existing years
        availableYears:
          Array.isArray(action.availableYears) && action.availableYears.length > 0
            ? action.availableYears
            : state.availableYears,
      };
    case GET_AVAILABLE_YEARS_SUCCESS:
      return {
        ...state,
        yearsLoading: false,
        availableYears: Array.isArray(action.payload)
          ? action.payload.sort((a, b) => Number(a) - Number(b))
          : [],
      };

    case GET_YEAR_QUESTIONS_FAIL:
      return {
        ...state,
        qLoading: false,
        error: action.payload,
      };
    case GET_AVAILABLE_YEARS_FAIL:
      return {
        ...state,
        yearsLoading: false,
        yearsError: action.payload,
      };

    case CLEAR_AVAILABLE_YEARS:
      console.log('CLEAR_AVAILABLE_YEARS reducer executed');
      return {
        ...state,
        availableYears: [],
        yearsLoading: false,
        qLoading: false,
      };

    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
        yearsError: null,
      };

    default:
      return state;
  }
};
